export default __webpack_public_path__ + "static/media/img-42-bari.462d47e7.jpg";